import qs from 'query-string';

export const queryString = (): { [key: string]: string | string[] | null } => {
  return qs.parse(window.location.search);
};
